import * as React from 'react';
import dayjs from 'dayjs';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import './Countdown.css';

const CountdownCell = (props: GridCustomCellProps) => {
  const [, setTime] = React.useState(Date.now());

  React.useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  if (!props.field || props.rowType !== 'data') return null;
  if (!props.dataItem[props.field]) return <td {...props.tdProps} />;

  const msDuration = dayjs.utc(props.dataItem[props.field]).diff(dayjs());
  if (msDuration <= 0) {
    return <td {...props.tdProps} className="countdown-critical">Expired</td>
  }
  const duration = dayjs.duration(msDuration);

  if (duration.asDays() > 1) {
    const formattedDuration = `${duration.days()}d ${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s`;
    return <td {...props.tdProps}>{formattedDuration}</td>;
  }

  const formattedDuration = `${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s`;
  if (duration.asMinutes() > 10) {
    return <td {...props.tdProps}>{formattedDuration}</td>;
  }

  if (duration.asMinutes() > 5) {
    return <td {...props.tdProps} className="countdown-warning">{formattedDuration}</td>;
  }

  return <td {...props.tdProps} className="countdown-critical">{formattedDuration}</td>;
}

export default CountdownCell;
